import { InputStateEnum } from '../../shared/utils/state';

/**
 * State Classes
 */

export const stateClasses = new Map([
  [InputStateEnum.Default, ''],
  [InputStateEnum.Success, ''],
  [InputStateEnum.Error, ''],
  [InputStateEnum.Disabled, 'pointer-events-none opacity-40'],
]);

export const inputDropdownClasses = 'flex flex-col flex-wrap gap-1';
